import { TextButton } from '@wix/design-system'
import { ArrowLeft } from '@wix/wix-ui-icons-common'
import React, { ComponentProps, FC, MouseEventHandler } from 'react'
import { useMediaQuery } from 'react-responsive'

import { LARGE_DESKTOP } from '../../../breakpoints'

interface BackButtonProps {
  text: string
  skin?: ComponentProps<typeof TextButton>['skin']
  onClick?: MouseEventHandler<HTMLElement>
  dataHook?: string
}

export const BackButton: FC<BackButtonProps> = ({ text, skin = 'dark', onClick, dataHook }) => {
  const isLargeDesktopScreen = useMediaQuery(LARGE_DESKTOP)

  return (
    <TextButton
      skin={skin}
      size={isLargeDesktopScreen ? 'medium' : 'small'}
      prefixIcon={<ArrowLeft />}
      onClick={onClick}
      dataHook={dataHook}
    >
      {text}
    </TextButton>
  )
}
